// JSON POST with the Rails CSRF token. Resolves with the parsed body on 2xx,
// rejects with { status, body } otherwise.
export const postJson = (url, body) => {
  const token = document.querySelector('meta[name="csrf-token"]')

  return fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": token ? token.content : "",
    },
    body: JSON.stringify(body),
  }).then((response) =>
    response
      .json()
      .catch(() => ({}))
      .then((data) => (response.ok ? data : Promise.reject({ status: response.status, body: data })))
  )
}

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Shows or clears the error text under a field and wires aria-invalid / aria-describedby.
export const setFieldError = (input, message) => {
  const error = document.getElementById(`${input.id}-error`)
  if (error) error.textContent = message || ""
  if (message) {
    input.setAttribute("aria-invalid", "true")
    if (error) input.setAttribute("aria-describedby", error.id)
  } else {
    input.removeAttribute("aria-invalid")
  }
}
